import { ModelViewerLocation } from './model-viewer-location.dto';
import { DateUtilities } from '@dermloop/utils';
import { Expose, Transform } from 'class-transformer';
import {
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

export class HealthRecordConditionQueryResultDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  health_record_id: string;

  @Expose()
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  ssn?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  mrn?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  first_name?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  last_name?: string;

  @Expose()
  @IsOptional()
  @Transform(({ value }) => DateUtilities.ensureIsDate(value))
  birth_date?: Date;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  study_participation_consent?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  application_improvements_participation_consent?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  anonymisation_for_educational_purposes_consent?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  further_questions_consent?: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toISOString())
  consents_updated_date?: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  gender_id: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  gender_name: string;

  @Expose()
  @IsOptional()
  @IsString()
  condition_id?: string;

  /** @deprecated Use condition_id */
  @Expose()
  @IsOptional()
  @IsString()
  lesion_id?: string;

  @Expose()
  @IsOptional()
  @ValidateNested()
  @Transform(({ value }) => (value ? JSON.parse(value) : value))
  condition_location?: ModelViewerLocation;

  /** @deprecated Use condition_location */
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Transform(({ value }) => (value ? JSON.parse(value) : value))
  lesion_location?: ModelViewerLocation;

  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toISOString())
  condition_created?: string;

  /** @deprecated Use condition_created */
  @Expose()
  @IsString()
  @IsOptional()
  @Transform(({ value }) => value?.toISOString())
  lesion_created?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  condition_created_by_user_id?: string;

  /** @deprecated Use condition_created_by_user_id */
  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  lesion_created_by_user_id?: string;

  @Expose()
  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => (value ? parseInt(value) : null))
  condition_creation_order?: number;

  /** @deprecated Use condition_creation_order */
  @Expose()
  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => (value ? parseInt(value) : null))
  lesion_creation_order?: number;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  triage_created_by_user_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toISOString())
  triage_updated?: string;

  @Expose()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  condition_complete: boolean;

  /** @deprecated Use condition_complete */
  @Expose()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  lesion_complete: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  latest_action?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  latest_action_details?: string;

  @Expose()
  @IsOptional()
  @IsNotEmpty()
  @IsString()
  @Transform(({ value }) => value?.toString())
  clinical_image_id?: string;

  @Expose()
  @IsOptional()
  @IsNumber()
  focal_point_x?: number;

  @Expose()
  @IsOptional()
  @IsNumber()
  focal_point_y?: number;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toString())
  image_medical_unit_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  condition_triage_id?: string;

  /** @deprecated Use condition_triage_id */
  @Expose()
  @IsOptional()
  @IsString()
  lesion_triage_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => (value ? value?.toString() : null))
  condition_latest_diagnosis_name?: string;

  /** @deprecated Use condition_latest_diagnosis_name */
  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => (value ? value?.toString() : null))
  lesion_latest_diagnosis_name?: string;

  @Expose()
  @IsBoolean()
  @Transform(({ value }) => !!value?.toString())
  is_triage_diagnosed: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  patient_details_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  patient_medical_unit_id?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Transform(({ value }) => value?.toISOString())
  patient_details_created?: string;

  @Expose()
  @IsOptional()
  @IsString()
  skin_type_id?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  pregnancy_within_last6_months?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  former_skin_cancer?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  former_melanoma?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  former_carcinoma?: boolean;

  @Expose()
  @IsOptional()
  @IsString()
  other_former_skin_cancer?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  family_history_of_melanoma?: boolean;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  has_risk_factors?: boolean;

  @Expose()
  @IsOptional()
  @IsString({ each: true })
  @Transform(({ value }) => (value ? value?.split(',') : null))
  risk_factors?: string[];

  @Expose()
  @IsOptional()
  @IsString()
  other_risks?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => (value != undefined ? !!value : null))
  has_objective_findings?: boolean;

  @Expose()
  @IsOptional()
  @IsString({ each: true })
  @Transform(({ value }) => (value ? value?.split(',') : null))
  objective_findings?: string[];

  @Expose()
  @IsOptional()
  @IsString()
  other_objective_findings?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  can_be_deleted?: boolean;
}
